import type { ColumnFilter } from '@witmetrics/utils';
import {
  COMPARISON_OPERATORS,
  PROJECT_STATUSES,
} from '@witmetrics/utils/constants';
import { buildColumnFilter } from '@witmetrics/utils/filters';

const { DOES_NOT_EQUAL, EQUALS } = COMPARISON_OPERATORS;
const { DONE, IN_PROGRESS, PENDING_APPROVAL } = PROJECT_STATUSES;

export const PROJECT_TAB = {
  ALL: 'ALL',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
} as const;

export type ProjectTab = (typeof PROJECT_TAB)[keyof typeof PROJECT_TAB];

export const PAGE_SIZE = 10;

export const TAB_FILTERS: Record<ProjectTab, ColumnFilter> = {
  [PROJECT_TAB.ALL]: buildColumnFilter(
    'unisonProjectStatusId',
    DOES_NOT_EQUAL.value,
    DONE.id
  ),
  [PROJECT_TAB.IN_PROGRESS]: buildColumnFilter(
    'unisonProjectStatusId',
    EQUALS.value,
    IN_PROGRESS.id
  ),
  [PROJECT_TAB.PENDING_APPROVAL]: buildColumnFilter(
    'unisonProjectStatusId',
    EQUALS.value,
    PENDING_APPROVAL.id
  ),
};
